import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39de84fe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39de84fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39de84fe')) {
      api.createRecord('39de84fe', component.options)
    } else {
      api.reload('39de84fe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=39de84fe&scoped=true", function () {
      api.rerender('39de84fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/distributor/pending/index.vue"
export default component.exports